import { BudgetResetTypeValues } from 'src/components/oneCorp/features/MealCredit/common/formFields/Select/BudgetResetTypeSelect/BudgetResetTypeSelect.utils';
import { MealCreditLength } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';
import { getSingularOrPlural } from 'src/utilities/getSingularOrPlural';
import { getRefreshText } from 'src/components/oneCorp/features/MealCredit/utils/getRefreshText';
import { MealCreditInfoTextProps } from './constructMealCreditInfoText.utils';

export function getTextForRefreshUseCases(
  props: Pick<
    MealCreditInfoTextProps,
    | 'budgetResetPeriod'
    | 'isDailyLengthBudget'
    | 'isWeeklyLengthBudget'
    | 'isMonthlyLengthBudget'
    | 'budgetLength'
    | 'budgetResetType'
    | 'expirationDate'
  >
): string {
  const {
    budgetResetPeriod,
    isDailyLengthBudget,
    isWeeklyLengthBudget,
    isMonthlyLengthBudget,
    budgetLength,
    budgetResetType,
    expirationDate,
  } = props;

  const refreshText = getRefreshText(expirationDate);

  const isCustomDaysLengthBudget =
    budgetLength === MealCreditLength.CUSTOM &&
    budgetResetType === BudgetResetTypeValues.DAYS;

  const isCustomWeeksLengthBudget =
    budgetLength === MealCreditLength.CUSTOM &&
    budgetResetType === BudgetResetTypeValues.WEEKS;

  const isCustomMonthsLengthBudget =
    budgetLength === MealCreditLength.CUSTOM &&
    budgetResetType === BudgetResetTypeValues.MONTHS;

  if (isDailyLengthBudget) {
    return `${refreshText} day`;
  }

  if (isCustomDaysLengthBudget) {
    return `${refreshText} ${budgetResetPeriod} ${getSingularOrPlural(
      budgetResetPeriod,
      'day'
    )}`;
  }

  if (isCustomWeeksLengthBudget) {
    return `${refreshText} ${budgetResetPeriod} ${getSingularOrPlural(
      budgetResetPeriod,
      'week'
    )}`;
  }

  if (isCustomMonthsLengthBudget) {
    return `${refreshText} ${budgetResetPeriod} ${getSingularOrPlural(
      budgetResetPeriod,
      'month'
    )}`;
  }

  if (isWeeklyLengthBudget) {
    return `${refreshText} week`;
  }

  if (isMonthlyLengthBudget) {
    return `${refreshText} month`;
  }

  return '';
}
